import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DashboardCard = ({ title, value, icon, color, colSize = "col-xl-3" }) => {
  return (
    <div className={`${colSize} col-md-6 mb-4`}>
      <div className={`card border-left-${color} shadow h-100 py-2`}>
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col mr-2">
              <div className={`text-xs font-weight-bold text-${color} text-uppercase mb-1`}>
                {title}
              </div>
              <div className="h5 mb-0 font-weight-bold text-gray-800">{value}</div>
            </div>
            <div className="col-auto">
              <FontAwesomeIcon icon={icon} className="fa-2x text-gray-300" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;